import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { PrintOnIcon } from "../../../assets/icons/CustomIcons";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import InputField from "../../../common/components/FormFields/InputField";
import RadioField from "../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { errorAlert } from "../../../common/components/Toasts/CustomToasts";
import {
  fetchCompany,
  fetchItemCategory,
  fetchItemClass,
  fetchItemType,
  fetchStore,
} from "../../../commonServices/miscellaneousServices/MiscServices";
import {
  getGenericName,
  getItemName,
  getItemStockList,
} from "../../services/inventoryStockServices/InventoryStockService";
import CurrentStockPrint from "../../prints/inventorystock/CurrentStockPrint";
import InventoryStockPrinmodal from "./inventoryStockPrint/InventoryStockPrintmodal";
import DaysPrint from "../../prints/inventorystock/DaysPrint";
import CurrentStockNonCosignment from "../../prints/inventorystock/CurrentStockNonCosignment";
import ItemExpirydetailsPrint from "../../prints/inventorystock/ItemExpirydetailsPrint";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";
import { useLocation } from "react-router-dom";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import ItemStockPrint from "../../prints/inventorystock/ItemStockPrint";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";

export default function InventoryStock() {
  let getUserInfo = JSON.parse(localStorage.getItem("userInfo"));

  const AssetTypeArray = [
    { id: 0, label: "All", value: 0 },
    { id: 1, label: "Fixed", value: 1 },
    { id: 2, label: "Non Fixed", value: 2 },
  ];

  const allexpiryItemDaily = [
    { id: 3, label: "Current Stock", vallue: 3 },
    { id: 1, label: "All Expiry Items", value: 1 },
    { id: 2, label: "Days", value: 2 },
  ];

  const defaultValues = {
    store: null,
    assetType: "0",
    allexpiryItemDaily: 3,
    itemType: null,
    itemCategory: null,
    generic: null,
    itemClass: null,
    itemName: null,
    manufacturer: null,
    days: 0,
    batchWise: false,
    withoutBatchWise: false,
  };

  const { control, watch, setValue, register, reset, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues,
  });

  let [
    storeVal,
    itemTypeVal,
    itemCategoryVal,
    genericVal,
    itemClassVal,
    itemVal,
    manufacturerVal,
    assetTypeVal,
    getBatchWise,
    getWithoutBatchWise,
  ] = watch([
    "store",
    "itemType",
    "itemCategory",
    "generic",
    "itemClass",
    "itemName",
    "manufacturer",
    "assetType",
    "batchWise",
    "withoutBatchWise",
  ]);

  let allexpiryItemDailyVal = Number(watch("allexpiryItemDaily"));
  let watchDays = Number(watch("days"));

  console.log("watchDays", watchDays);

  const location = useLocation();
  const [showSpinner, setShowSpinner] = useState(false);
  const [storeOptions, setStoreOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
  const [genericOptions, setGenericOptions] = useState([]);
  const [itemClassOptions, setItemClassOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [count, setCount] = React.useState();
  const [dataResult, setDataResult] = useState([]);
  const [userAction, setUserActions] = useState(null);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    if (open) {
      setOpen(false);
    }
  };

  const [openprintModal, setOpenprintModal] = useState(false);
  const [printObject, setPrintObject] = useState(null);

  const renderPrint = (component) => {
    setTimeout(() => {
      setOpenprintModal(false);
    }, 5000);

    return (
      <div className="hidden">
        {/* {Number(allexpiryItemDailyVal) === 1 && (
          <ItemExpirydetailsPrint storeVal={storeVal} watchDays={Number(0)} />
        )}

        {Number(allexpiryItemDailyVal) === 2 && (
          <DaysPrint storeVal={storeVal} watchDays={watchDays} />
        )}

        {Number(allexpiryItemDailyVal) === 3 && (
          <CurrentStockPrint storeVal={storeVal} />
        )}

        {Number(allexpiryItemDailyVal) === 4 && <CurrentStockNonCosignment />} */}

        <ItemStockPrint
          printObject={printObject}
          allexpiryItemDailyVal={allexpiryItemDailyVal}
        />
      </div>
    );
  };

  const populateTable = (forPagination) => {
    let defaultParams = {
      isFixedAsset: Number(assetTypeVal),
      itemCategoryId: itemCategoryVal !== null ? itemCategoryVal?.id : null,
      itemClassId: itemClassVal !== null ? itemClassVal?.id : null,
      itemCompanyId: manufacturerVal !== null ? manufacturerVal?.id : null,
      itemGenericId: genericVal !== null ? genericVal?.id : null,
      itemId: itemVal !== null ? itemVal?.id : null,
      itemTypeId: itemTypeVal !== null ? itemTypeVal?.id : null,
      storeId: storeVal !== null ? storeVal?.id : null,
      batchWise:
        getBatchWise === true
          ? true
          : getWithoutBatchWise === true
          ? false
          : null,
      allExpiryItems: allexpiryItemDailyVal === 1 ? true : false,
      days: watchDays > 0 ? watchDays : null,
      page: page,
      size: rowsPerPage,
    };
    setPrintObject(defaultParams);
    setShowSpinner(true);
    getItemStockList(defaultParams)
      .then((response) => {
        return response.data;
      })
      .then((res) => {
        if (forPagination) {
          setShowSpinner(false);
          setDataResult((prevData) => [...prevData, ...res.result]);
        } else {
          setShowSpinner(false);
          setDataResult(res.result);
        }
        setCount(res?.result[0]?.count);
      })
      .catch((error) => {
        setShowSpinner(false);
        errorAlert(error.message);
      });
  };

  //Item Name
  const handleChange = (autoServceSearchString) => {
    if (autoServceSearchString !== "") {
      getItemName(autoServceSearchString)
        .then((response) => response.data)
        .then((res) => {
          setItemOptions(res.result);
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    }
  };

  const handleChangeForGenericName = (autoServceSearchString) => {
    if (autoServceSearchString !== "") {
      getGenericName(autoServceSearchString)
        .then((response) => response.data)
        .then((res) => {
          setGenericOptions(res.result);
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    }
  };

  useEffect(() => {
    fetchStore()
      .then((response) => response.data)
      .then((res) => {
        setStoreOptions(res.result);
      });

    fetchItemType()
      .then((response) => response.data)
      .then((res) => {
        setItemTypeOptions(res.result);
      });
    // item category dropdown api
    fetchItemCategory()
      .then((response) => response.data)
      .then((res) => {
        setItemCategoryOptions(res.result);
      });
    // item class dropdown api
    fetchItemClass()
      .then((response) => response.data)
      .then((res) => {
        setItemClassOptions(res.result);
      });
    //CompanyOptions
    fetchCompany()
      .then((response) => response.data)
      .then((res) => {
        setManufacturerOptions(res.result);
      });
  }, []);

  useEffect(() => {
    //Tabel
    if (storeVal) {
      populateTable();
    }
  }, [
    storeVal,
    itemTypeVal,
    itemCategoryVal,
    genericVal,
    itemClassVal,
    itemVal,
    manufacturerVal,
    assetTypeVal,
    getBatchWise,
    getWithoutBatchWise,
    allexpiryItemDailyVal,
    watchDays,
  ]);

  useEffect(() => {
    let logStore = {
      id: getUserInfo.storeId,
      label: getUserInfo.storeName,
      value: getUserInfo.storeId,
    };

    if (getUserInfo.storeId !== null && getUserInfo.storeName !== null) {
      setValue("store", logStore);
    }

    // USER ACTIONS
    location?.state?.menuId &&
      fetchUserActionsByMenuId(location?.state?.menuId)
        .then((response) => response.data)
        .then((res) => {
          setUserActions(res.result);
        });
  }, []);

  useEffect(() => {
    if (Number(allexpiryItemDailyVal) !== 2) {
      setValue("days", 0);
    }
    // if (Number(allexpiryItemDailyVal) !== 3) {
    //   setValue("batchWise", false);
    //   setValue("withoutBatchWise", false);
    // }
  }, [allexpiryItemDailyVal]);

  return (
    <div className="mt-12 mb-2 px-3">
      <h1 className="text-center text-black font-bold text-xl">Item Stock</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-2 gap-y-3">
        <DropdownField
          control={control}
          name="store"
          placeholder="Store"
          dataArray={storeOptions}
          isSearchable={true}
          isClearable={true}
        />
        <DropdownField
          control={control}
          name="itemType"
          placeholder="ItemType"
          dataArray={itemTypeOptions}
          isSearchable={true}
          isClearable={true}
        />
        <DropdownField
          control={control}
          name="itemCategory"
          placeholder="Item Category"
          dataArray={itemCategoryOptions}
          isSearchable={true}
          isClearable={true}
        />
        <SearchDropdown
          control={control}
          name="generic"
          placeholder="Generic Name"
          searchIcon={true}
          isSearchable={true}
          isClearable={true}
          dataArray={genericOptions}
          handleInputChange={handleChangeForGenericName}
        />
        <DropdownField
          control={control}
          name="itemClass"
          placeholder="Item Class"
          dataArray={itemClassOptions}
          isSearchable={true}
          isClearable={true}
        />
        <SearchDropdown
          control={control}
          name="itemName"
          placeholder="Item Name"
          searchIcon={true}
          isSearchable={true}
          isClearable={true}
          dataArray={itemOptions}
          handleInputChange={handleChange}
        />
        <DropdownField
          control={control}
          name="manufacturer"
          placeholder="Manufacturer"
          dataArray={manufacturerOptions}
          isSearchable={true}
          isClearable={true}
        />
        <fieldset className=" flex w-full justify-center items-center bg-white border rounded px-2 -mt-2">
          <legend className="text-xs font-semibold px-2">Asset Type</legend>
          <div className="-my-2">
            <RadioField
              control={control}
              name="assetType"
              dataArray={AssetTypeArray}
            />
          </div>
        </fieldset>
        <div className="flex flex-wrap space-x-2 items-center col-span-2 lg:col-span-3 2xl:col-span-2">
          <div className="flex col-span-2 items-center">
            <RadioField
              label=""
              name="allexpiryItemDaily"
              control={control}
              dataArray={allexpiryItemDaily}
            />
            <div className="w-[60px]">
              <InputField
                type="number"
                control={control}
                label="Days"
                name="days"
                disabled={allexpiryItemDailyVal !== 2}
              />
            </div>
          </div>
          <div className="flex items-center">
            <fieldset
              onChange={() => {
                setValue("withoutBatchWise", false);
              }}
            >
              <CheckBoxField
                control={control}
                name="batchWise"
                label="Batch"
                // disabled={allexpiryItemDailyVal !== 3}
              />
            </fieldset>
            <fieldset
              onChange={(e) => {
                setValue("batchWise", false);
              }}
            >
              <CheckBoxField
                control={control}
                name="withoutBatchWise"
                label="Without Batch"
                // disabled={allexpiryItemDailyVal !== 3}
              />
            </fieldset>
          </div>
          <div className="flex justify-end items-center">
            <Tooltip title="Print Stock">
              <button
                onClick={() => {
                  setOpenprintModal(true);
                }}
              >
                <PrintOnIcon />
              </button>
            </Tooltip>
          </div>
        </div>
      </div>

      {showSpinner ? (
        <div className="flex pt-6 justify-center">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          {dataResult.length > 0 ? (
            <>
              <CommonDynamicTablePaginationNew
                dataResult={dataResult}
                populateTable={populateTable}
                highlightedRow={false}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                count={count}
                removeHeaders={[
                  "Id",
                  "IsCons",
                  "StockingUOM",
                  "MaxStockLevel",
                  "BatchCode",
                  "BatchExpDate",
                  "ScheduleH1",
                  "UnitMRP",
                  "Description",
                ]}
                tableHeading="Inventory Stock List"
                highlightRow={false}
                tableClass="h-[570px] 2xl:h-[580]"
              />
            </>
          ) : (
            <h1 className="flex items-center justify-center font-bold text-gray-600 mt-2 border rounded h-80 text-lg">
              No Record Found...
            </h1>
          )}
        </>
      )}

      <InventoryStockPrinmodal
        open={open}
        handleClose={handleClose}
        storeVal={storeVal}
      />

      {openprintModal && renderPrint()}
    </div>
  );
}
